export const getTabClasses = (isActiveTab: boolean) => {
  const baseClasses =
    'flex items-center h-[var(--ds-tab-sizing-height)] min-w-0 px-1.5 gap-1.5 focus:outline-none text-ds-400 leading-ds-300';

  if (isActiveTab) {
    return `${baseClasses} !bg-[var(--ds-tab-active-bg)] hover:!bg-[var(--ds-tab-active-hover-bg)] !text-[var(--ds-tab-active-color)]`;
  }
  return `${baseClasses} !bg-[var(--ds-tab-inactive-bg)] hover:!bg-[var(--ds-tab-inactive-hover-bg)] !text-[var(--ds-tab-inactive-color)]`;
};
